export default {
  routerList: [
    {
      path: '/homePageApp',
      component: () => import('@/views/indexApp/home/homePage.vue'),
      name: '主页（手机端）',
      children: []
    },
    {
      path: '/newListApp',
      component: () => import('@/views/indexApp/home/newList.vue'),
      name: '新闻列表（手机端）',
      children: []
    },
    {
      path: '/newDetailsApp',
      component: () => import('@/views/indexApp/home/newDetails.vue'),
      name: '新闻详情（手机端）',
      children: []
    },
    {
      path: '/searchApp',
      component: () => import('@/views/indexApp/home/search.vue'),
      name: '新闻搜索（手机端）',
      children: []
    },
    {
      path: '/introduceApp',
      component: () => import('@/views/indexApp/home/introduce.vue'),
      name: '部门简介（手机端）',
      children: []
    },
    {
      path: '/rmyjzjApp',
      component: () => import('@/views/indexApp/home/rmyjzj.vue'),
      name: '人民意见征集（手机端）',
      children: []
    },
    {
      path: '/wxjzApp',
      component: () => import('@/views/indexApp/home/wxjz.vue'),
      name: '微信矩阵（手机端）',
      children: []
    },
    {
      path: '/xxxtApp',
      component: () => import('@/views/indexApp/home/xxxt.vue'),
      name: '信息系统（手机端）',
      children: []
    },
    {
      path: '/bmdtMoreApp',
      component: () => import('@/views/indexApp/home/bmdtMore.vue'),
      name: '部门动态更多（手机端）',
      children: []
    },
    {
      path: '/xxydApp',
      component: () => import('@/views/indexApp/home/xxyd.vue'),
      name: '学习园地',
      children: []
    }


  ]
}
